import _classCallCheck from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var StarDrawer = /*#__PURE__*/function () {
  function StarDrawer() {
    _classCallCheck(this, StarDrawer);
  }

  _createClass(StarDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount(particle) {
      var _a, _b;

      var star = particle.shapeData;
      return (_b = (_a = star === null || star === void 0 ? void 0 : star.sides) !== null && _a !== void 0 ? _a : star === null || star === void 0 ? void 0 : star.nb_sides) !== null && _b !== void 0 ? _b : 5;
    }
  }, {
    key: "draw",
    value: function draw(context, particle, radius) {
      var _a;

      var star = particle.shapeData;
      var sides = this.getSidesCount(particle);
      var inset = (_a = star === null || star === void 0 ? void 0 : star.inset) !== null && _a !== void 0 ? _a : 2;
      context.moveTo(0, 0 - radius);

      for (var i = 0; i < sides; i++) {
        context.rotate(Math.PI / sides);
        context.lineTo(0, 0 - radius * inset);
        context.rotate(Math.PI / sides);
        context.lineTo(0, 0 - radius);
      }
    }
  }]);

  return StarDrawer;
}();